var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgModule(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.623 1.57a1.948 1.948 0 0 1 2.754 0l2.068 2.067L8 7.082 4.555 3.636 6.623 1.57zm-2.988 9.876L1.571 9.378a1.949 1.949 0 0 1 0-2.757l2.066-2.066 3.445 3.446-3.447 3.445zM14.43 6.622a1.948 1.948 0 0 1 0 2.757l-2.066 2.064-3.445-3.442 3.447-3.446 2.064 2.067zM9.376 14.43a1.949 1.949 0 0 1-2.754 0l-2.068-2.064L8 8.919l3.445 3.447-2.07 2.064z",
    fill: "#875BF7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModule);
export default __webpack_public_path__ + "static/media/module.8a451450006706441ba4939a5347356f.svg";
export { ForwardRef as ReactComponent };